import { apiClient } from '../../ruutsApi/client'
import endpoints from '../../ruutsApi/endpoints'
import { unwrapVoid } from '../../ruutsApi/normalize'

const OTHER_SITE_COLOR = 'hsl(300, 76%, 72%)'

export type OtherSiteToCreate = {
  properties: { name: string }
  geometry: { type: 'Point'; coordinates: readonly [number, number] }
}

// POST /v1/otherSites answers a plain string, not a {payload} envelope.
export const createOtherSite = async ({
  farmId,
  feature,
}: {
  farmId: string
  feature: OtherSiteToCreate
}): Promise<void> => {
  const [lng, lat] = feature.geometry.coordinates
  const response = await apiClient.post(endpoints.otherSites, {
    name: feature.properties.name,
    farmId,
    // The OtherSite model stores plannedLocation as [lat, lng], the reverse of GeoJSON.
    plannedLocation: [lat, lng],
    geometry: feature.geometry,
    color: OTHER_SITE_COLOR,
  })
  return unwrapVoid(response)
}
